














import { UserActionContexts } from '@/constants/urls'

export default {
  props: {
    patientNoun: {
      type: String,
      required: true,
    },
    patientFullName: {
      type: String,
      required: true,
    },
    userActionContext: {
      type: String,
      required: true,
    },
  },
  computed: {
    contextIsNew() {
      return this.userActionContext === UserActionContexts.New
    },
    confirmationText() {
      if (this.contextIsNew) {
        return `${this.patientFullName} was added to your ${this.patientNoun.toLowerCase()}s list.`
      }
      return `${this.patientNoun} information for ${this.patientFullName} was updated successfully.`
    },
  },
}
